import React, { type FC } from 'react';

import { ValueStyled } from './styled';
import type { ValueLabel } from '../../../index';
import { replaceVar } from '../../../../../utils/misc';

export type ValueProps = {
  minValue: number;
  maxValue: number;
  valueLabel?: string | ValueLabel;
  minAllowed: number;
  maxAllowed: number;
};

export const getLabelText = ({ valueLabel, minValue, maxValue, minAllowed, maxAllowed }: ValueProps) =>
  typeof valueLabel === 'string'
    ? replaceVar(valueLabel, { minValue: minValue.toString(), maxValue: maxValue.toString() })
    : valueLabel && valueLabel({ minValue, maxValue, minAllowed, maxAllowed });

const Value: FC<ValueProps> = (props) => {
  const { minValue = 0, maxValue = 0, valueLabel, minAllowed, maxAllowed } = props;
  const labelText = getLabelText({ valueLabel, minValue, maxValue, minAllowed, maxAllowed });

  return <ValueStyled className="oss-ui-slider-value-label">{labelText}</ValueStyled>;
};

export default Value;
